import { useEffect, useRef } from 'react';

export default function useInitialServerSortSync({
  initialSortModel,
  serverSideSorting,
  setSortModel,
  settingsLoading,
  tableKey,
}) {
  const hasAppliedPersistedSortRef = useRef(false);

  useEffect(() => {
    if (hasAppliedPersistedSortRef.current) return;
    if (settingsLoading) return;
    if (!serverSideSorting) return;
    if (!tableKey) return;
    if (initialSortModel?.length) {
      setSortModel?.(initialSortModel);
    }
    hasAppliedPersistedSortRef.current = true;
  }, [
    initialSortModel,
    serverSideSorting,
    setSortModel,
    settingsLoading,
    tableKey,
  ]);
}
